import React from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import CloseIcon from '../../assets/icons/JSX/CloseIcon'
import Colors from '../../assets/styles/Colors'
import { Scrollbar } from '../../assets/styles/GlobalStyle'
import Scissors from '../../assets/v2/JSX/Scissors'

const PromoCodeModal: React.FC<{
  isOpen: boolean
  onClose: () => void
  width?: 'fullWidth' | 'default'
  code?: string
  imageUrl?: string
  endDate?: string
  discountType?: string
  discountAmount?: number
  discountPercentage?: number
  discountDays?: number
}> = ({
  isOpen = false,
  onClose,
  width = 'default',
  code,
  imageUrl,
  endDate,
  discountType,
  discountAmount,
  discountPercentage,
  discountDays,
}) => {
  //
  const { t } = useTranslation()
  //
  // copy promo code
  const copyPolicyNumber = (e: any) => {
    e.stopPropagation()
    navigator?.clipboard?.writeText(e?.currentTarget?.innerText || '')
    toast.success(`${t('copied')}`)
  }
  //
  return isOpen === false ? null : (
    <Wrapper>
      <Scrollbar hideScroll={isOpen} />

      <ShadowBackground onClick={() => onClose()} />

      <Content $width={width}>
        <Block>
          <White>
            <CloseModalBtn className="base-modal-close-btn" onClick={() => onClose()}>
              <CloseIcon />
            </CloseModalBtn>

            <Image src={imageUrl} alt="promo-code-img" />

            {/* <Title>Welcome to Frani</Title> */}

            {discountType === 'amount' && (
              <Description
                dangerouslySetInnerHTML={{
                  __html: t('youHaveAmountPromoCode', { amount: discountAmount }),
                }}
              />
            )}

            {discountType === 'percentage' && (
              <Description
                dangerouslySetInnerHTML={{
                  __html: t('youHavePercentagePromoCode', { percent: discountPercentage }),
                }}
              />
            )}

            {discountType === 'days' && (
              <Description
                dangerouslySetInnerHTML={{
                  __html: t('youHaveDaysPromoCode', { days: discountDays }),
                }}
              />
            )}
          </White>

          <MidBlock>
            <ScissorsIcon />
          </MidBlock>

          <Gray>
            {/* <SecondTitle>
              {t('promoCodeText')}
              <Discount> 10$ off</Discount>
            </SecondTitle> */}

            <DiscountCode onClick={(event) => copyPolicyNumber(event)}>{code}</DiscountCode>

            <SomeText>
              {t('expireDate')}: {endDate}
            </SomeText>
          </Gray>
        </Block>
      </Content>
    </Wrapper>
  )
}
//
const Image = styled.img`
  height: 90px;
`
const ScissorsIcon = styled(Scissors)`
  position: absolute;
  z-index: 3;
  top: -15px;
  left: 5px;
`
const MidBlock = styled.div`
  position: relative;
  border-top: 2px dotted ${Colors.nevadaGrey};
  margin-inline: 33px;
  z-index: 5;
  user-select: none;
  pointer-events: none;
`
const SomeText = styled.span`
  color: ${Colors.nevadaGrey};
  font-size: 12px;
  padding-bottom: 28px;

  ${Responsive.mobile} {
    padding-bottom: 20px;
  }
`
const DiscountCode = styled.span`
  color: ${Colors.primaryBlack};
  padding: 14px 24px;
  background-color: ${Colors.white};
  border-radius: 4px;
  margin-block: 24px;
  cursor: pointer;
`
// const Discount = styled.span`
//   color: ${Colors.primaryRed};
//   font-weight: bold;
// `

// const Title = styled.span`
//   font-size: 18px;
//   text-align: center;
//   color: ${Colors.primaryBlack};
//   padding-block: 30px 18px;

//   ${Responsive.mobile} {
//     padding-block: 26px 18px;
//   }
// `
// const SecondTitle = styled(Title)`
//   padding-block: 34px 0px;

//   ${Responsive.mobile} {
//     font-size: 10px;
//   }
// `
const Description = styled.p`
  font-size: 14px;
  text-align: center;
  color: ${Colors.nevadaGrey};
  margin-bottom: 0px;
  padding-bottom: 34px;
  margin-top: 30px;
`
const White = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 0px 20px;
  background-color: ${Colors.white};
  border-radius: 8px 8px 0px 0px;
  margin-bottom: -1px;

  mask-image: radial-gradient(circle 10px at bottom left, transparent 0, transparent 20px, black 21px),
    radial-gradient(circle 10px at bottom right, transparent 0, transparent 20px, black 21px);
  mask-composite: intersect;

  ${Responsive.mobile} {
    svg {
      height: 88px;
    }
  }
`
const Gray = styled.div`
  margin-top: -1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${Colors.grey};
  padding: 0px 20px 20px 20px;
  border-radius: 0px 0px 8px 8px;

  mask-image: radial-gradient(circle 10px at top left, transparent 0, transparent 20px, black 21px),
    radial-gradient(circle 10px at top right, transparent 0, transparent 20px, black 21px);
  mask-composite: intersect;
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
`
const CloseModalBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: 0px;
  background-color: transparent;
  outline: none;
  padding: 10px;
  margin-right: -10px;
  margin-top: -10px;
  svg {
    width: 14px;
    height: 14px;
    color: ${Colors.rollingStone};
  }
  /*  */
  &:hover {
    svg {
      color: ${Colors.primaryBlack};
    }
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;
  width: 100%;
  overflow: hidden;
  z-index: 101;

  ${Responsive.mobile} {
    padding-inline: 25px;
  }
`
const ShadowBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: black;
  opacity: 0.3;
  width: 100%;
  height: 100vh;
`
const Content = styled.div<{ $width: string }>`
  z-index: 6;
  min-height: 20vh;
  height: fit-content;
  max-width: ${({ $width }) => ($width === 'fullWidth' ? `600px` : `464px`)};
  width: 100%;

  ${Responsive.mobile} {
    min-width: unset;
    width: 100%;
  }
`

export default PromoCodeModal
